import React from 'react';
import { format, isAfter } from 'date-fns';

import { CardDetails, GreyCard } from '../Cards';
import { Link, Small } from '../Text';
import { Button } from '../Buttons';
import { getLoggedTimeString } from '../../utils/textTransforms';

const TestPurchaseCard = ({ test_purchase: { id, booked_by, start_date, end_date, item, mileage, website, address, status }, documents, logged_time, onEdit, onComplete, onView }) => {
    start_date = format(start_date, 'DD/MM/YYYY HH:mm');

    let isCompleted = status === 'completed',
        needsCompleting = isAfter(new Date(), end_date) && !isCompleted;

    const loggedTimeString = getLoggedTimeString(logged_time);

    if(isCompleted) {
        onEdit = onView;
        onComplete = onView;
    }

    return(
        <GreyCard>
            <CardDetails
                title={`Test Purchase ${start_date}`}
                titleStyle={'rounded green'}
                onClick={() => onEdit(id)}
            >
                { website && <p>Website: { website }</p> }
                { address && <p>Location: { address }</p> }
                <p>by user: { booked_by.name }</p>
            </CardDetails>

            <CardDetails onClick={() => onEdit(id)}>
                <p>Time Logged: { loggedTimeString }</p>
                <p>Mileage Logged: { mileage ? `${mileage} miles` : 'N/A' }</p>
            </CardDetails>

            <CardDetails
                title={'Associated files:'}
                documents={true}
                noBackground={true}
                innerBackground={true}
            >
                { documents.map(doc => <GreyCard mini={true} key={`doc${doc.id}`}><a href={doc.url} target={"_blank"} style={{ fontSize: '12px', wordBreak: 'break-all' }}>{ doc.name }</a></GreyCard>) }
                { needsCompleting ?
                    <Button
                        onClick={() => onComplete(id)}
                        blueLight={true}
                        chunkyish={true}
                    >Add Test Purchase Outcome</Button>
                    :
                    !isCompleted ?
                        <Link small={true} underline={true} el={'button'} onClick={() => onEdit(id)}>Edit/add details</Link>
                        :
                        <Link small={true} underline={true} el={'button'} onClick={() => onView(id)}>View details</Link>
                }
            </CardDetails>
        </GreyCard>
    );
}

export default TestPurchaseCard;